import React from 'react';
import { ABSModal } from '../ABSModal';
import ABSFlexibleForm, { IConfig } from '../ABSFlexibleForm';

export interface IABSFlexibleModalProps {
  onConfirm: (valuesObj: any, callback: (noReset?: boolean) => void) => void;
  onClose?: () => void;
  config: IConfig[];
  title: string;
  children: React.ReactElement<any>;
  labelWidth?: number;
}

export interface IABSFlexibleModalState {}

class ABSFlexibleModal extends React.Component<
  IABSFlexibleModalProps,
  IABSFlexibleModalState
> {
  modal: ABSModal | null;
  flexibleForm: ABSFlexibleForm | null;

  onConfirm = () => {
    const result = this.flexibleForm ? this.flexibleForm.validatorValue() : 0;
    if (result) { 
      const { onConfirm } = this.props;
      const value = this.flexibleForm ? this.flexibleForm.getValue() : null;
      onConfirm(value, (noReset?: boolean) => {
        this.show(false);
        if (!noReset) {
          this.reset();
        }
      });
    }
  };

  reset = () => {
    if (this.flexibleForm) {
      this.flexibleForm.reset();
    }
  };

  validatorValue = () => {
    const result = this.flexibleForm ? this.flexibleForm.validatorValue() : 0;
    return result;
  };

  onClose = () => {
    this.reset();
  };

  show = (show: boolean) => {
    if (this.modal) {
      this.modal.show( show );
    }
  };

  render() {
    const { title, children, config } = this.props;
    return (
    <>
      {children}
      <ABSModal
        content={<ABSFlexibleForm ref={view => this.flexibleForm = view} config={config}/>}
        title={title}
        width={500}
        ref={view => this.modal = view}
        onClose={this.onClose}
        onConfirm={this.onConfirm}
      />
    </>
    );
  }
}

export default ABSFlexibleModal;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSFlexibleModal/index.tsx